export default "__VITE_ASSET__BGO$l8eg__"